/**
 * Layout for all the calculator views
 */
import React, { Component } from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import Header from '../UI/Header'
import { menuItems, device } from '../../utils/helpers'
import CalculatorSidebar from '../Calculator/Sidebar'
import CalculatorFooter from '../UI/Footer/CalculatorFooter'
import Footer from '../UI/Footer'

const Wrapper = styled.div`
  min-height: 100%;

  @media ${device.tablet} {
    overflow: hidden;
  }
`

const Content = styled.main`
  display: flex;
`

const FooterWrapper = styled.div`
  display: none;

  @media ${device.tablet} {
    display: flex;
    margin-right: auto;
    margin-top: auto;
  }
`

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 110px;

  @media ${device.tablet} {
    width: ${props => props.isCollapsed ? '93%' : '78%'};
    position: fixed;
    overflow: auto;
    top: 100px;
    ${''/* top: 95px; */}
    bottom: 10px;
    padding-top: 0;
  }

  @media ${device.desktop} {
    top: 120px
  }
`

const MobileFooter = styled.div`
  display: block;
  padding-top: 30px;

  @media ${device.tablet} {
    display: none;
  }
`

class CalculatorLayout extends Component {
  state = {
    isCollapsed: true
  }
  // To set whether sidebar is collapsed or not
  // to be used by check the width of wrapper
  updateCollapsedStatus (status) {
    this.setState({ isCollapsed: status })
  }

  render () {
    const { children } = this.props // The content of the page
    const { sport } = this.props.match.params // Sport token from URL
    const { isCollapsed } = this.state
    const { pathname } = this.props.location
    return (
      <Wrapper>
        <Header menuItems={menuItems} />
        <Content>
          <ContentWrapper isCollapsed={isCollapsed}>
            {children}
            <FooterWrapper>
              <CalculatorFooter />
            </FooterWrapper>
          </ContentWrapper>
          <CalculatorSidebar isCollapsed={this.updateCollapsedStatus.bind(this)} collapsed={!sport || pathname.includes('7')} />
        </Content>
        <MobileFooter>
          <Footer />
        </MobileFooter>
      </Wrapper>
    )
  }
}

export default withRouter(CalculatorLayout)



// WEBPACK FOOTER //
// ./src/components/Layout/Calculator.js